export enum CustomersAppRoutesEnum {
  CUSTOMERS_APP_LIST = 'customersapp-list',
  CUSTOMERS_APP_DETAIL = 'customersapp-detail',
}
